import { createContext } from "react";

export const DEFAULT_VISIT_LINK_TEXT = "View Rates";

export const ThemeContext = createContext({
	visitLinkText: DEFAULT_VISIT_LINK_TEXT,
});
